import * as React from 'react';
import styled from 'styled-components';

import t from '../../shared/translations';
import { IData } from './index';

interface IProps {
    data: IData;
}

const Main = styled.div`
    flex-grow: 1;
`;

function UsedPage({ data }: IProps): JSX.Element {
    return <Main>
        <h1>{t('public.create-account-used.heading', { title: data.webappTitle })}</h1>
        <p>
            {t('public.create-account-used.info-login', { title: data.webappTitle })}{' '}
            <a href='/login'>{t('public.create-account-used.info-login-link')}</a>
        </p>
        <p>
            {t('public.create-account-used.info-problems')}
        </p>
    </Main>;
}

export default UsedPage;
